import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import NotificationButton from '../components/NotificationButton';
import SwitchToggle from '../components/SwitchToggle';
import './Notifications.css';

const Notifications = () => {
  const [notificationPermission, setNotificationPermission] = useState('default');
  const [isSubscribed, setIsSubscribed] = useState(false);

  useEffect(() => {
    const checkNotificationStatus = async () => {
      try {
        const permission = await window.OneSignal.getNotificationPermission();
        const subscribed = await window.OneSignal.getSubscription();
        
        setNotificationPermission(permission);
        setIsSubscribed(subscribed);

        // Écouter les changements de permission
        window.OneSignal.on('notificationPermissionChange', (permissionChange) => {
          setNotificationPermission(permissionChange.to);
        });

        // Écouter les changements de souscription
        window.OneSignal.on('subscriptionChange', (isSubscribed) => {
          setIsSubscribed(isSubscribed);
        });
      } catch (error) {
        console.error('Erreur vérification notifications:', error);
      }
    };

    checkNotificationStatus();

    // Cleanup
    return () => {
      window.OneSignal.off('notificationPermissionChange');
      window.OneSignal.off('subscriptionChange');
    };
  }, []);

  const handleToggle = async () => {
    try {
      if (isSubscribed) {
        await window.OneSignal.setSubscription(false);
      } else {
        if (notificationPermission === 'granted') {
          await window.OneSignal.setSubscription(true);
        } else {
          await window.OneSignal.registerForPushNotifications();
        }
      }
    } catch (error) {
      console.error('Erreur toggle notifications:', error);
    }
  };

  const getNotificationStatus = () => {
    // Si l'utilisateur a la permission
    if (notificationPermission === 'granted') {
      return (
        <div className="notification-status success">
          <div className="notification-header">
            <span>Notifications</span>
            <SwitchToggle
              isEnabled={isSubscribed}
              onToggle={handleToggle}
            />
          </div>
          <p>
            {isSubscribed 
              ? 'Vous recevrez les nouveautés et promotions en temps réel.'
              : 'Activez les notifications pour ne rien manquer !'}
          </p>
        </div>
      );
    }
    // Si l'utilisateur a refusé les notifications
    else if (notificationPermission === 'denied') {
      return (
        <div className="notification-status warning">
          <span>⚠️ Notifications bloquées</span>
          <p>Vous devez autoriser les notifications dans les paramètres de votre navigateur.</p>
          <NotificationButton permission={notificationPermission} />
        </div>
      );
    }
    // État initial ou par défaut
    else {
      return (
        <div className="notification-status default">
          <span>🔔 Restez informé</span>
          <p>Activez les notifications pour ne rien manquer !</p>
          <NotificationButton permission={notificationPermission} />
        </div>
      );
    }
  };

  return (
    <motion.div
      className="notifications-page"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <div className="notifications-container">
        {getNotificationStatus()}
      </div>
    </motion.div>
  );
};

export default Notifications; 